import React from 'react';
import { NodeAttribution } from './nodeCodes';

interface Props {
  attribution: NodeAttribution | null;
}

/**
 * Node attribution line — "Registered by Schmidt Auctions (SCH)".
 * The call sign is derived from the scanned NODE token via nodeCodes; the legacy
 * long form (SCHMIDT) and the 3-letter form (SCH) both render the same node.
 */
const VerifyAttribution: React.FC<Props> = ({ attribution }) => {
  if (!attribution) return null;
  return (
    <div className="border-x border-gray-200 px-5 py-3 bg-white">
      <p className="text-sm text-gray-600">
        Registered by{' '}
        <span className="font-medium text-gray-900">{attribution.displayName}</span>
        {attribution.callSign && (
          <span className="text-gray-500"> ({attribution.callSign})</span>
        )}
      </p>
    </div>
  );
};

export default VerifyAttribution;
